import { render, staticRenderFns } from "./StreetName.vue?vue&type=template&id=85faf842&"
import script from "./StreetName.vue?vue&type=script&lang=ts&"
export * from "./StreetName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports